import { useQuery } from '@apollo/client';
import { useAuth } from 'oidc-react';
import { GET_USER } from '../home/home.graphql';

/** Language editors (CanEditDictionary) edit terms; everyone else can read and comment. */
export const useCanEditDictionary = () => {
  const auth = useAuth();
  const { data } = useQuery(GET_USER, { variables: { userId: auth?.userData?.profile.sub } });
  return data?.users?.[0]?.canEditDictionary ?? false;
};
